import { create } from 'zustand';

const API_BASE = '/api';

type AvatarEntry = { status: 'loading' } | { status: 'loaded'; url: string } | { status: 'none' };

interface AvatarState {
  /** userId -> loading state or image URL (object URL) or 'none' (404). */
  cache: Record<string, AvatarEntry>;
  /** Start loading avatar for userId if not already loaded. Idempotent. */
  loadAvatar: (userId: string) => void;
}

export const useAvatarStore = create<AvatarState>((set, get) => ({
  cache: {},

  loadAvatar(userId: string) {
    const { cache } = get();
    if (cache[userId]) return;

    set((state) => ({
      cache: { ...state.cache, [userId]: { status: 'loading' } },
    }));

    fetch(`${API_BASE}/users/${encodeURIComponent(userId)}/avatar`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) {
          set((state) => ({
            cache: { ...state.cache, [userId]: { status: 'none' } },
          }));
          return;
        }
        return res.blob();
      })
      .then((blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        set((state) => ({
          cache: { ...state.cache, [userId]: { status: 'loaded', url } },
        }));
      })
      .catch(() => {
        set((state) => ({
          cache: { ...state.cache, [userId]: { status: 'none' } },
        }));
      });
  },
}));

export function getAvatarEntry(userId: string): AvatarEntry | undefined {
  return useAvatarStore.getState().cache[userId];
}
